<template>
  <div
    class="modal topic-thread-modal fade w-100"
    id="topicThreadModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="loginModalLabel"
    aria-hidden="true"
  >
    <lightbox id="thread_lightbox" ref="thread_lightbox" :images="selectedPostImages"></lightbox>
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div v-if="topic && first_post" class="content mb-4">
            <div>
              <div class="content-header">
                <div class="d-flex align-items-start">
                  <img
                    class="content-header__avatar rounded-circle mt-1"
                    width="40"
                    height="40"
                    src="../../../assets/avatar.png"
                    alt
                  />
                  <div class="content-header__description ml-2">
                    <div class="content-header__info">
                      <router-link
                        :to="'/profile/' + topic.profile_id"
                        class="content-header__name mr-1"
                        data-dismiss="modal"
                      >{{ topic.profile.name }}</router-link>
                      <span>&rsaquo;</span>
                      <a class="ml-1 font-weight-bold" style="color: inherit">{{ topic.title }}</a> &middot;
                      <span role="time">{{ topic.created | happroxy }}</span>
                    </div>
                    <div class="content-header__meta">
                      <span role="role" v-if="topic.is_admin">Admin</span>
                      <span role="role" v-else>Member</span> &middot;
                      <router-link
                        :to="'/circle/' + topic.circle_id"
                        class="content-header__name"
                        data-dismiss="modal"
                      >{{ topic.circle.title }}</router-link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="content-body">
                <div class="content-body__text">
                  <p v-html="first_post.body"></p>
                </div>
              </div>

              <div class="content-media px-3" v-if="first_post.media_uploads.length > 0">
                <div
                  class="card-columns photo-grid"
                  :style="`column-count:${calculateColumns(first_post.media_uploads)}`"
                >
                  <div class="photo-grid__photo">
                    <img
                      v-for="img in first_post.media_uploads"
                      :key="img._id"
                      class="img-fluid"
                      v-lazy="img.upload.path"
                      @click="showImage(img.upload.path, first_post._id)"
                    />
                  </div>
                </div>
              </div>

              <div class="content-footer" v-if="userCanComment">
                <div class="action-links d-flex"></div>

                <div class="add-comment d-flex align-items-start mt-4">
                  <img class="rounded-circle mr-2" width="34" src="../../../assets/avatar.png" alt />
                  <div class="form-group w-100">
                    <div class="comment-input w-100">
                      <textarea
                        :id="topic._id + '_threadinput'"
                        @input="checkValid($event, topic._id)"
                        type="text"
                        name="comment"
                        class="form-control"
                        placeholder="Add a comment"
                      />
                      <ion-icon name="ios-images" @click="toggleUpload(topic._id)"></ion-icon>
                      <div class="d-flex justify-content-between align-items-center mt-1">
                        <span></span>
                        <!-- Use v-else on this span for balance -->
                        <small
                          :id="topic._id + '_threadvalidation'"
                          class="text-light-grey"
                        >0/{{ MAX_CHAR_LEN }}</small>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Uploads -->
                <div
                  :id="'thread-uploads-group' + topic._id"
                  hidden
                  class="form-group uploads-group"
                  style="margin-left:38px"
                >
                  <div
                    class="upload-frame mb-3"
                    v-for="image in getDocImages(topic._id)"
                    :key="image.id"
                    :style="'background-image:' + image.src"
                  >
                    <span class="close" @click="removeImage(image.id)">
                      <ion-icon name="ios-close"></ion-icon>
                    </span>
                  </div>

                  <div
                    class="upload-frame upload-frame--add"
                    :class="[(getDocImages(topic._id).length === 0) ? 'mr-2' : '']"
                    :hidden="getDocImages(topic._id).length === 4"
                    @click="selectImageFromFS(topic._id)"
                  >
                    <span class="add">
                      <ion-icon name="ios-add-circle"></ion-icon>
                    </span>
                    <input
                      :id="topic._id + '_threadimage-input'"
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      hidden
                      @change="imageSelectCallback($event, topic._id)"
                    />
                  </div>
                </div>

                <div
                  :id="topic._id + '_threadbtnflex'"
                  class="d-flex justify-content-end flex-hidden"
                >
                  <button
                    class="btn btn-primary clear-both"
                    disabled
                    :id="topic._id + '_threadbtn'"
                    @click="submit(topic)"
                  >Post</button>
                </div>
              </div>

              <div v-if="thread && thread.length > 0" class="content-comments">
                <div class v-for="post in thread" :key="post._id">
                  <div class="content-comments__single">
                    <div class="content-header">
                      <div class="d-flex align-items-start">
                        <img
                          class="content-header__avatar rounded-circle mt-1"
                          width="34"
                          height="34"
                          src="../../../assets/avatar.png"
                          alt
                        />
                        <div class="content-header__description ml-2">
                          <div class="content-header__info">
                            <router-link
                              :to="'/profile/' + post.profile_id"
                              class="content-header__name mr-1"
                              data-dismiss="modal"
                            >{{ post.profile.name }}</router-link>
                          </div>
                          <div class="content-header__meta">
                            <span role="role" v-if="post.is_admin">Admin</span>
                            <span role="role" v-else>Member</span> &middot;
                            <span role="time">{{ post.created | happroxy }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="content-body">
                      <div class="content-body__text">
                        <p>{{ post.body }}</p>
                      </div>
                    </div>

                    <div class="content-media px-3" v-if="post.media_uploads.length > 0">
                      <div
                        class="card-columns photo-grid"
                        :style="`column-count:${calculateColumns(post.media_uploads)}`"
                      >
                        <div class="photo-grid__photo">
                          <img
                            v-for="img in post.media_uploads"
                            :key="img._id"
                            class="img-fluid"
                            v-lazy="img.upload.path"
                            @click="showImage(img.upload.path, post._id)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <intersect @enter="reachedEndOfThread()">
                  <span></span>
                </intersect>
              </div>
            </div>
          </div>
          <EmptyFeed
            v-if="thread && thread.length === 0"
            emptyFeedFor="profile"
            altText="No comments on this post"
          />
          <ContentSkeleton v-if="contentLoading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataHandlerService from "@/services/data";
import ContentService from "@/services/content";
import * as constants from "@/constants/index";
import FileUtils from "@/utils/file";
import RandomValues from "@/utils/random";
import { mapState } from "vuex";
import ContentSkeleton from "@/components/Main/ContentSkeleton/ContentSkeleton.vue";
import EmptyFeed from "@/components/Main/EmptyFeed/EmptyFeed.vue";
import InMemoryDb from "@/services/inmemorydb";
import Intersect from "vue-intersect";
import router from "@/router";

const data = new DataHandlerService();
const contentService = new ContentService();
const fileUtils = new FileUtils();
const randomValues = new RandomValues();
const InMemoryDatabase = new InMemoryDb();
const LIMIT = constants.LIMIT;

export default {
  name: "TopicThread",
  components: { ContentSkeleton, Intersect, EmptyFeed },
  props: ["topic_id", "isUserMember"],
  data() {
    return {
      user: data.getUserData(),
      MAX_CHAR_LEN: constants.MAX_POST_CHAR_LEN,
      imagePool: [],
      topic: null,
      first_post: null,
      thread: null,
      contentLoading: true,
      page: 0,
      threadImages: [],
      selectedPostImages: [],
      temp_thread: null,
      userCanComment: false
    };
  },
  mounted() {

    const modal = document.getElementById("topicThreadModal");

    const disposeThread = function() {
      if (modal.style.display === "none") {
        this.$emit("ThreadDismissed");
      }
    };

    this.$root.$on("ShowThread", id => {
      this.loadContent(id);
    });

    this.$root.$on("NewPostAdded", post => {
      if (modal.style.display !== "none") {
        if (this.topic) {
          if (post.topic_id === this.topic._id) {
            if (this.thread) {
              this.thread = this.sort([...this.thread, post]);
              this.temp_thread = this.sort([...this.temp_thread, post]);
            } else {
              this.thread = [post];
              this.temp_thread = [post];
            }
            this.savePostImages(post);
          }
        }
      }
    });

    this.$root.$on("PostModified", post => {
      if (this.topic) {
        if (post.topic_id === this.topic._id) {
          const threadIndex = this.thread.findIndex(s => s._id === post._id);
          const tempThreadIndex = this.temp_thread.findIndex(
            s => s._id === post._id
          );
          if (threadIndex > -1) {
            this.thread.splice(threadIndex, 1, post);
          }
          if (tempThreadIndex > -1) {
            this.temp_thread.splice(tempThreadIndex, 1, post);
          }
        }
      }
    });

    modal.addEventListener("blur", disposeThread.bind(this));
  },
  computed: {
    ...mapState(["circles"])
  },
  watch: {
    topic_id: async function(val) {
      console.log(val)
      if (val) {
        this.loadContent(val);
      } else {
        this.topic = null;
        this.first_post = null;
        this.thread = null;
        this.threadImages = [];
        this.contentLoading = true;
        this.temp_thread = null;
      }
    },
    circles: function(val) {
      if (val) {
        if (this.topic) {
          this.canUserComment(this.topic.circle_id);
        }
      }
    }
  },
  methods: {
    calculateColumns(photos) {
      if (photos.length === 1) return 1;
      else if (photos.length > 1 && photos.length < 5) return 2;
      else return 3;
    },
    showImage(name, post_id) {
      this.selectedPostImages = this.threadImages.filter(
        image => image.post_id === post_id
      );
      this.$refs.thread_lightbox.show(name);
    },
    canUserComment(circle_id) {
      if (this.circles) {
        this.userCanComment =
          this.circles.findIndex(s => s._id === circle_id) > -1;
      }
    },
    checkValid(e, doc_id) {
      const submit_btn = document.getElementById(`${doc_id}_threadbtn`);
      const submit_btn_flex = document.getElementById(
        `${doc_id}_threadbtnflex`
      );
      const validation = document.getElementById(`${doc_id}_threadvalidation`);

      const valid = charLen => {
        validation.classList.add("text-light-grey");
        validation.classList.remove("form-error-text");
        validation.innerText = `${charLen}/${constants.MAX_POST_CHAR_LEN}`;
      };

      const invalid = charLen => {
        validation.classList.remove("text-light-grey");
        validation.classList.add("form-error-text");
        validation.innerText = `${charLen}/${constants.MAX_POST_CHAR_LEN}`;
      };

      if (!e) {
        submit_btn.disabled = true;
        submit_btn_flex.classList.add("flex-hidden");
        valid(0);
      } else {
        if (e.srcElement.value.length === 0) {
          submit_btn.disabled = true;
          submit_btn_flex.classList.add("flex-hidden");
          valid(0);
        } else {
          submit_btn_flex.classList.remove("flex-hidden");
          if (e.srcElement.value.length <= constants.MAX_POST_CHAR_LEN) {
            submit_btn.disabled = false;
            valid(e.srcElement.value.length);
          } else {
            submit_btn.disabled = true;
            invalid(e.srcElement.value.length);
          }
        }
      }
    },
    submit(doc) {
      const inputEl = document.getElementById(`${doc._id}_threadinput`);
      const submit_btn = document.getElementById(`${doc._id}_threadbtn`);

      const form = {
        body: inputEl.value,
        status: "active",
        circle_id: doc.circle_id,
        topic_id: doc._id,
        profile_id: this.user._id
      };

      inputEl.disabled = true;
      submit_btn.disabled = true;
      submit_btn.innerText = "Posting";
      submit_btn.classList.add("btn--loading");

      const commentImages = this.getDocImages(doc._id);

      const successAction = function() {
        inputEl.disabled = false;
        inputEl.value = "";
        submit_btn.innerText = "Post";
        submit_btn.classList.remove("btn--loading");
        this.$notification.new("Comment posted");
        this.imagePool = this.imagePool.filter(s => s.doc_id !== doc._id);
      };

      const failureAction = function(response) {
        inputEl.disabled = false;
        submit_btn.disabled = false;
        submit_btn.innerText = "Post";
        submit_btn.classList.remove("btn--loading");
        this.$root.$emit("ShowErrorNotification", response.message);
      };

      if (commentImages.length > 0) {
        contentService
          .createCommentWithImages(form, commentImages)
          .then(post => {
            if (post) {
              this.$root.$emit("SaveNewPost", post);
            }
            successAction.call(this);
          })
          .catch(response => failureAction.call(this, response));
      } else {
        contentService
          .createComment(form)
          .then(post => {
            if (post) {
              this.$root.$emit("SaveNewPost", post);
            }
            successAction.call(this);
          })
          .catch(response => failureAction.call(this, response));
      }
    },
    toggleUpload(doc_id) {
      const uploads_group = document.getElementById(
        `thread-uploads-group${doc_id}`
      );
      uploads_group.hidden = !uploads_group.hidden;
    },
    getDocImages(doc_id) {
      return this.imagePool.filter(s => s.doc_id === doc_id);
    },
    removeImage(imageId) {
      this.imagePool.splice(
        this.imagePool.findIndex(s => s.id === imageId),
        1
      );
    },
    selectImageFromFS(doc_id) {
      if (this.getDocImages(doc_id) !== 4) {
        const hiddenImageInput = document.getElementById(
          `${doc_id}_threadimage-input`
        );
        hiddenImageInput.click();
      }
    },
    async imageSelectCallback(e, doc_id) {
      const files = e.target.files || e.dataTransfer.files;
      const validationStatus = fileUtils.validateFile(files);
      if (validationStatus.valid) {
        this.imagePool.push({
          id: randomValues.secureRandString(),
          file: files[0],
          src: await fileUtils.getSrc(files),
          doc_id
        });
      } else {
        this.$root.$emit("ShowErrorNotification", validationStatus.message);
      }
    },
    sort(arr) {
      return arr.sort((a, b) => {
        const [A, B] = [a.created, b.created];
        if (A < B) {
          return 1;
        }
        if (A > B) {
          return -1;
        }
        return 0;
      });
    },
    async fetchContentFromAPISinglePage(topic_id, page) {
      let thread = null;
      const fetchPostsFromAPI = [
        contentService.readTopicPosts(topic_id, LIMIT, page)
      ];

      await Promise.all(fetchPostsFromAPI)
        .then(res => {
          res = res[0];
          let response = res.content;
          thread = this.temp_thread || [];
          response.map(item => {
            const existingPost = thread.find(
              feedItem => feedItem._id === item._id
            );
            if (!existingPost) {
              thread.push(item);
            }
            this.savePostImages(item);
            InMemoryDatabase.addPost(item);
          });

          if (this.page > res.max) {
            res.content.length < LIMIT
              ? (this.page = res.max - 1)
              : (this.page = res.max);
          }
        })
        .catch(err => {
          err && err.message
            ? this.$root.$emit("ShowErrorNotification", err.message)
            : this.$root.$emit(
                "ShowErrorNotification",
                "An error occurred. Please try again."
              );
          return null;
        });
      return thread;
    },
    async fetchContentFromAPIMultiPage(topic_id, max_page) {
      let fetchRequests = [];
      let thread = null;
      for (let i = 1; i <= max_page; i++) {
        fetchRequests = [
          ...fetchRequests,
          contentService.readTopicPosts(topic_id, LIMIT, i)
        ];

        if (i === max_page) {
          await Promise.all(fetchRequests)
            .then(res => {
              let response = [];
              res.map(s => (response = [...response, ...s.content]));
              thread = this.temp_thread || [];
              response.map(item => {
                const existingPost = thread.find(
                  feedItem => feedItem._id === item._id
                );
                if (!existingPost) {
                  thread.push(item);
                }
                this.savePostImages(item);
                InMemoryDatabase.addPost(item);
              });
            })
            .catch(err => {
              err && err.message
                ? this.$root.$emit("ShowErrorNotification", err.message)
                : this.$root.$emit(
                    "ShowErrorNotification",
                    "An error occurred. Please try again."
                  );
              return null;
            });
          return thread;
        }
      }
    },
    async reachedEndOfThread() {
      this.contentLoading = true;
      const thread = await this.fetchContentFromAPISinglePage(
        this.topic._id,
        ++this.page
      );
      if (thread) {
        this.thread = this.sort(
          thread.filter(s => s._id !== this.first_post._id)
        );
      }
      this.contentLoading = false;
    },
    savePostImages(post) {
      post.media_uploads.map(img => {
        const existingIndex = this.threadImages.findIndex(
          s => s.id === img._id
        );
        if (existingIndex > -1) {
          this.threadImages.splice(existingIndex, 1, {
            name: img.upload.path,
            id: img._id,
            post_id: post._id
          });
        } else {
          this.threadImages.push({
            name: img.upload.path,
            id: img._id,
            post_id: post._id
          });
        }
      });
    },
    async loadContent(topic_id) {
      let topic = await InMemoryDatabase.getTopic(topic_id);
      if (topic && Object.keys(topic).length > 0) {
        this.topic = topic;
        this.canUserComment(topic.circle_id);
        const first_post = await InMemoryDatabase.getPost(
          topic.first_media._id
        );
        if (first_post && Object.keys(first_post).length > 0) {
          this.first_post = first_post;
          this.savePostImages(first_post);

          let thread = (await InMemoryDatabase.getTopicPosts(topic._id)) || [];
          thread = this.sort(thread.filter(s => s._id !== first_post._id));
          this.page = Math.round(thread.length / LIMIT);

          if (thread.length > 0) {
            this.temp_thread = thread;
            this.thread = thread;
            this.thread.map(post => this.savePostImages(post));
            this.contentLoading = !this.contentLoading;
          }
        }
        contentService
          .readSinglePost(topic.first_media._id)
          .then(async post => {
            this.first_post = post;
            this.savePostImages(post);
            InMemoryDatabase.addPost(post);

            if (this.page > 1) {
              if (this.page > 5) {
                this.page = 5;
              }
              const thread = await this.fetchContentFromAPIMultiPage(
                topic._id,
                this.page
              );
              if (thread) {
                this.thread = this.sort(
                  thread.filter(s => s._id !== this.first_post._id)
                );
              }
              if (this.contentLoading) {
                this.contentLoading = false;
              }
            } else {
              this.page = 1;
              const thread = await this.fetchContentFromAPISinglePage(
                topic._id,
                1
              );
              if (thread) {
                this.thread = this.sort(
                  thread.filter(s => s._id !== this.first_post._id)
                );
              }
              if (this.contentLoading) {
                this.contentLoading = false;
              }
            }
          })
          .catch(err => {
            err && err.message
              ? this.$root.$emit("ShowErrorNotification", err.message)
              : this.$root.$emit(
                  "ShowErrorNotification",
                  "An error occurred. Please try again."
                );
          });
      } else {
        contentService
          .readSingleTopic(topic_id)
          .then(async _topic => {
            if (_topic) {
              topic = _topic;
              this.canUserComment(_topic.circle_id);
              this.topic = topic;
              InMemoryDatabase.addTopic(topic);

              const first_post = await InMemoryDatabase.getPost(
                topic.first_media._id
              );
              if (first_post && Object.keys(first_post).length > 0) {
                this.first_post = first_post;
                this.savePostImages(first_post);

                let thread =
                  (await InMemoryDatabase.getTopicPosts(topic._id)) || [];
                thread = this.sort(
                  thread.filter(s => s._id !== first_post._id)
                );
                this.page = Math.round(thread.length / LIMIT);

                if (thread.length > 0) {
                  this.temp_thread = thread;
                  this.thread = thread;
                  this.thread.map(post => this.savePostImages(post));
                  this.contentLoading = !this.contentLoading;
                }
              }
              contentService
                .readSinglePost(topic.first_media._id)
                .then(async post => {
                  this.first_post = post;
                  this.savePostImages(post);
                  InMemoryDatabase.addPost(post);

                  if (this.page > 1) {
                    if (this.page > 5) {
                      this.page = 5;
                    }
                    const thread = await this.fetchContentFromAPIMultiPage(
                      topic._id,
                      this.page
                    );
                    if (thread) {
                      this.thread = this.sort(
                        thread.filter(s => s._id !== this.first_post._id)
                      );
                    }
                    if (this.contentLoading) {
                      this.contentLoading = false;
                    }
                  } else {
                    this.page = 1;
                    const thread = await this.fetchContentFromAPISinglePage(
                      topic._id,
                      1
                    );
                    if (thread) {
                      this.thread = this.sort(
                        thread.filter(s => s._id !== this.first_post._id)
                      );
                    }
                    if (this.contentLoading) {
                      this.contentLoading = false;
                    }
                  }
                })
                .catch(err => {
                  err && err.message
                    ? this.$root.$emit("ShowErrorNotification", err.message)
                    : this.$root.$emit(
                        "ShowErrorNotification",
                        "An error occurred. Please try again."
                      );
                });
            } else {
              Array.from(document.getElementsByClassName("modal-backdrop")).map(
                el => (el.style.display = "none")
              );
              router.replace({ path: `/404` });
            }
          })
          .catch(err => {
            err && err.message
              ? this.$root.$emit("ShowErrorNotification", err.message)
              : this.$root.$emit(
                  "ShowErrorNotification",
                  "An error occurred. Please try again."
                );
          });
      }
    }
  }
};
</script>
<style scoped lang="scss" src="../FeedContent/FeedContent.scss"></style>